'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'trees';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f724';
var svgPathData = 'M192 0c7 0 13.7 3.1 18.2 8.4l96 112 2.1 2.8c4.3 6.8 5 15.4 1.5 22.8-3.9 8.5-12.4 14-21.8 14l-16.9 0 75.2 88.5c6 7.1 7.4 17.1 3.5 25.6S337.4 288 328 288l-24.9 0 75.2 88.5c6 7.1 7.4 17.1 3.5 25.6S369.4 416 360 416l-136 0 0 64c0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32l0-64-136 0c-9.4 0-17.9-5.5-21.8-13.9s-2.6-18.5 3.5-25.6L80.9 288 56 288c-9.4 0-17.9-5.5-21.8-13.9s-2.6-18.5 3.5-25.6L112.9 160 96 160c-9.4 0-17.9-5.5-21.8-14s-2.5-18.5 3.6-25.7l96-112 1.8-1.9C180 2.4 185.9 0 192 0zM448 0c7 0 13.7 3.1 18.2 8.4l96 112 2.1 2.8c4.3 6.8 5 15.4 1.5 22.8-3.9 8.5-12.4 14-21.8 14l-16.9 0 75.2 88.5c6 7.1 7.4 17.1 3.5 25.6S593.4 288 584 288l-24.9 0 75.2 88.5c6 7.1 7.4 17.1 3.5 25.6S625.4 416 616 416l-136 0 0 64c0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32l0-42.8c3.7-4.5 6.8-9.5 9.3-14.9l0 0c11-23.9 8.1-51.7-7.2-72.7l-3.3-4.1 0 0-30.8-36.3c3.6-4.5 6.8-9.5 9.3-14.9l0 0c11-23.9 8.1-51.7-7.2-72.7l-3.3-4.1 0 0-35.1-41.3c2.1-3.2 4-6.5 5.7-10l0 0c9.7-21 8.5-45-2.3-64.7l-.5-.8 79.1-92.2 1.8-1.9C436 2.4 441.9 0 448 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrees = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;